import { render, staticRenderFns } from "./EditionCreateNew.vue?vue&type=template&id=2d17477a&scoped=true"
import script from "./EditionCreateNew.vue?vue&type=script&lang=js"
export * from "./EditionCreateNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d17477a",
  null
  
)

export default component.exports